var Drawer = function Drawer(_ref) {
  var spacing = _ref.spacing;
  return {
    padding: {
      top: spacing.small,
      right: spacing.xxxlarge,
      bottom: spacing.xxlarge,
      left: spacing.xxxlarge
    },
    width: {
      "default": 600
    }
  };
};

export default Drawer;